import { IShapeBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IDrawingShapeDataModel } from '@tencent/slide-sdk-model';

interface ShapeTags {
    isTemplate: boolean;
    type: 'title' | 'content' | 'image' | 'list';
}

const parseJson = <T = any>(value: string): T | null => {
    try {
        return JSON.parse(value);
    } catch (error) {
        return null;
    }
};

const getShapeTags = (shape: IDrawingShapeDataModel): ShapeTags | null => {
    const descr = shape.props.nvPr?.descr;
    if (!descr) return null;

    return parseJson(descr);
};

/** 通过 ai 生成标签判定 Shape 是否为标题 */
export const isTitleShape = (shapeModel: IShapeBaseModel) => {
    if (shapeModel.parent?.type !== UIModelType.SLIDE) return false;
    if (!shapeModel.sdkData) return false;

    const tags = getShapeTags(shapeModel.sdkData as any as IDrawingShapeDataModel);

    return tags?.isTemplate && tags.type === 'title';
};
